import React from 'react';
import FederalFinancingTotals from './FerderalFinancingTotals';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const FederalFinancingTotalsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'do Financiamento Federal'
            }}
        >
            <FederalFinancingTotals />
        </ServicesChartsDataProvider>
    );
};

export default FederalFinancingTotalsWrapper;
